import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './FilterMenu.css';
import { Split } from '../GlossaryTerm/GlossaryTerm';
import GoogleSearchInput from '../GoogleSearchInput/GoogleSearchInput';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Section } from '../../importCL';

interface IGlossaryTerms {
    term: string;
    description: string;
    url?: string;
    relatedTerms: string[];
}

interface IFilterMenuProps extends MappedComponentProperties {
    title?: string;
    textBelowTitle?: string;
    enabledLetters?: string[];
    glossaryTerms?: IGlossaryTerms[];
    letter?: string;
    landingUrl?:string;
    menuHidden?: boolean
}

export const FilterMenuEditConfig = {
    emptyLabel: 'Filter Menu',
    isEmpty: (props: PropsWithChildren<IFilterMenuProps>) => {
        return !props || !props.title;
    },
};

const TabTiles: string[] = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];

const reformatUrl = (url: string) : string => {
    if (url.includes('.html')) return (url.replace('.html', '') + '.html');
    return url;
};

const Tabs = (props: { landingUrl?:string, fixedArray?: IGlossaryTerms[], terms?:IGlossaryTerms[], resetTerms?: any, activeTab?: string; tt: string[], disabledArray: string[] }) => {
    const isLandingPage = window.location.pathname === props.landingUrl ?? false;
    return (
        <div className='bg-grey-alabaster rounded border border-solid border-[#d8d8d8] rounded my-6 mx-auto px-5 py-0'>
            <ul className='pl-0 flex flex-wrap justify-center list-none text-center !m-0'>
                {props.tt.map((tab, index) => {
                    const isActive = props.activeTab?.toLowerCase() === tab.toLowerCase() ?? false;
                    return (
                        <li className='m-0' key={index}>
                            <a href={ isActive && !isLandingPage ? props.landingUrl : reformatUrl(props.landingUrl + '/' + tab.toLowerCase())}>
                                <button
                                    className={`letterBtn ${isActive ? 'text-white bg-blue-creditone' : ''}`}
                                    disabled={!props.disabledArray.includes(tab.toLowerCase())}
                                    type='button'
                                    role='link'>
                                    {tab}
                                </button>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

const FilterMenu = (props: PropsWithChildren<IFilterMenuProps>): JSX.Element => {
    const activeTab = props.letter || '';
    const sorted= props.glossaryTerms?.sort((a, b) => a.term.toLowerCase() > b.term.toLowerCase() ? 1 : -1);
    const [selectedTerms, setSelectedTerms] = useState(sorted);
    const [inputVal, setInputVal] = useState('');
    const landingUrl = props.landingUrl as string;

    useEffect(() => {
        if (activeTab) {
            const filteredLinks = selectedTerms?.filter((res) => {
                return res.term[0] === activeTab.toLowerCase();
            });
            setSelectedTerms(filteredLinks);
        } else {
            setSelectedTerms(sorted);
        }
    }, [activeTab]);
    return (
        <div id='filter-menu'>
            <Section className='!pb-0 !pt-12'>
                <h1>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.title))}</h1>
                <p className='mb-0'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.textBelowTitle))}</p>
            </Section>
            <Section className='!pb-0'>
                <GoogleSearchInput  placeHolderText='Search by entering a keyword or topic'
                    showX={!!inputVal}
                    inputValue={inputVal}
                    setInputValue={setInputVal}
                    onXClick={() => {
                        setInputVal(''); 
                    }}
                    googleAutoComplete={true}
                    resultsUrl='articles/glossary/search'
                    autocompleteFilter='/articles/glossary'/>
            </Section>
            { !props.menuHidden &&   <>
                <Section className='!pb-2 !px-2 !pt-[0.3rem]'>
                    <div>
                        <Tabs
                            landingUrl={landingUrl}
                            fixedArray={sorted}
                            terms={selectedTerms}
                            resetTerms={setSelectedTerms}
                            activeTab={activeTab}
                            tt={TabTiles}
                            disabledArray={
                                props.enabledLetters?.map((x) => x.toLowerCase()) ?? ['']
                            }
                        />
                    </div>
                </Section>
                <Section>
                    <ul className='flex flex-wrap list-none m-0 gap-y-4'>
                        {selectedTerms?.map((term, index) => {
                            if (term.term.toLowerCase() !== 'search') {
                                return (
                                    <li className='FilterMenu__Glossary_terms' key={index}>
                                        <a href={`${term.url}`} role='term'>
                                            {Split(term.term)}
                                        </a>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                </Section>
            </>}
        </div>
    );
};

export default FilterMenu;